import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CustomersService } from '../services/customers/customers-service';

@Injectable()
export class CustomerEmailExistsValidator {

  debouncer: any;
  private id: number|null;

  excludeId(id: number|null) {
    this.id = id;
    return {checkEmail: this.checkEmail};
  }

  checkEmail(control: FormControl): any {
    let self: CustomerEmailExistsValidator = this;
    return new Promise(resolve => {
      this.debouncer = setTimeout(() => {
        this.custService
          .search({email: String(control.value).trim()})
          .subscribe(
            (res) => {
              if(res.filter(function(r){
                if(r.hasOwnProperty("CONTACTID"))
                {
                  return String(r.email).trim().toLowerCase() === String(control.value).trim()
                     && (self.id && self.id>0 ? self.id.toString() !== r.CONTACTID.toString() : true);
                }
                return String(r.email).trim().toLowerCase() === String(control.value).trim();
              }).length > 0) {
                resolve({"email_taken": true});
              }
              else {
                resolve(null);
              }
            },
            (err) => {
              resolve({"can't reach server": true});
            }
          );
      }, 350);
    });
  }

  constructor(public custService: CustomersService) {}
}



// WEBPACK FOOTER //
// ./src/validators/customer-email-exists.ts